import { FC } from "react";
import { Styled } from "../../types";
import { TitleWithStyles } from "../../general";
export const HeaderWithChildren: FC<
  React.PropsWithChildren<Styled & { title: string }>
> = ({ title, children }) => {
  return (
    <div className="flex align-bottom gap-3 mb-8">
      <TitleWithStyles title={title} />
      {children}
    </div>
  );
};
